import { render, staticRenderFns } from "./OneColumnText.vue?vue&type=template&id=7566e4db&scoped=true&"
import script from "./OneColumnText.vue?vue&type=script&lang=js&"
export * from "./OneColumnText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566e4db",
  null
  
)

export default component.exports